import React, { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"

import { UserContext } from "src/providers"

import "./style.css"
import { NavigationButton } from "src/components/cards/NavigationButton"
import { Box, Container, Grid, Typography } from "@mui/material"
import { TabletTile } from "./TabletTile"
import { getIcon, getPath, Tablet } from "src/models/company"

const HomePage: React.FC = () => {
  const navigate = useNavigate()
  const { companyPortalProperties, tablets } = useContext(UserContext)

  return (
    <Box className="home">
      <Container
        sx={{
          pt: { xs: 2, md: 6, lg: 8 },
          pb: { xs: 4, md: 8 },
          px: { xs: 0, md: 6, lg: 8 },
          flex: 1
        }}
        maxWidth={"xl"}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          sx={{
            p: { xs: 2, md: 6, lg: 8 }
          }}
        >
          {tablets.map((tablet, index, arr) => {
            const small = index > 2 || arr.length > 7
            return (
              <Grid key={tablet.id} item xs={6} sm={4} md={4} lg={small ? 3 : 4} xl={small ? 3 : 4}>
                <TabletTile
                  title={tablet.title}
                  imageSrc={getIcon(tablet)}
                  onClick={() => navigate(getPath(tablet))}
                  type={tablet.type}
                  status={tablet.status}
                  small={small}
                />
              </Grid>
            )
          })}
        </Grid>
        {companyPortalProperties.showDiscoverMe && (
          <NavigationButton title="Discover More" onClick={() => navigate("/more")} />
        )}
      </Container>
    </Box>
  )
}

export default HomePage
